<div class="title-bar">
    <div class="greeting">
        <div>Hello there...</div>
        <div class="username user-details">{{ username }}</div>
    </div>
    <img class="main-logo" (click)="refresh()" src="../../assets/images/logo-lg.png" alt="Refresh" />
    <div>
        <app-notification-bell></app-notification-bell>
        <div ngbDropdown class="dropdown popout" placement="bottom-end">
        <button ngbDropdownToggle id="dropdownMenuButton" class="menu-btn">
            <img src="../../assets/icons/menu/burger.png" alt="Popout">
        </button>
        <div ngbDropdownMenu class="menu-dropdown">
            <div class="menu-item">
                <a (click)="closeMenu()" [ngClass]="{ selected: currentPage === '/tasks' }"
                    [routerLink]="['/tasks/']" routerLinkActive="router-link-active">
                    <span class="menu-icon" [ngClass]="{ 'selected':currentPage === '/tasks' }"
                        style="background-image: url('../../assets/icons/menu/task-blue.svg');"></span>
                    <span>Tasks</span>
                </a>
            </div>
            <div class="menu-item">
            <a (click)="closeMenu()"  [ngClass]="{ selected: currentPage === '/upjar' }"
                [hidden]="!canViewUpjar" [routerLink]="['/upjar/']" routerLinkActive="router-link-active">
                <span class="menu-icon" [ngClass]="{ selected: currentPage === '/upjar'}"
                    style="background-image: url('../../assets/icons/menu/upjar.svg');"></span>
                <span>Upjar</span>
            </a>
            </div>
            <div class="menu-item">
            <a (click)="logout()">
                <span class="menu-icon sign-out" style="background-image: url('../../assets/icons/buttons/circle-arrow.svg');"></span>
                <span class="sign-out-text">Sign Out</span>
            </a>
            </div>
        </div>
    </div>
    </div>
</div>